const PRIVILEGES = {
  TOOLS_REMOVE_MAPPINGS: 1,
  TOOLS_TRIGGER_ORCHESTRATION: 2,
  TOOLS_MAP_COURSES:3,
  TOOLS_RESET_CUSTOMER:4,
  TOOLS_CREATE_ONE_ROSTER:5,
  TOOLS_OVERWRITE_SOURCE_ID:6,
  TOOLS_RESET_BATCH:7,
  TOOLS_PRODUCT_ASSIGNMENT_REPORT:8,
  TOOLS_PAUSE_UNPAUSE_SERVICE:9,
  TOOLS_MANAGE_DEAD_QUEUES:10,
  TOOLS_DELETE_ENTITY:11,
  TOOLS_PURCHASING_ACCOUNTS: 12,
  TOOLS_CANCEL_WORKFLOWS: 13,
  TOOLS_ADMIN_PERMISSIONS: 14,
  TOOLS_SFTP_BATCH_TRIGGER: 15,
  TOOLS_MANAGE_CLEVER_CREDENTIALS: 16,
  TOOLS_TRIGGER_SUBGROUP_ORCHESTRATION: 17,
  TOOLS_RESET_SUBGROUP_DATA: 18
};

export default PRIVILEGES;



// WEBPACK FOOTER //
// ./app/models/privileges.js